// extracted by css-extract-rspack-plugin
export default {"content":"_32b1eb71","contactButton":"_a00e832e"};